module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/sub-brands/sub-brands.component.css
// module id = ./src/app/sub-brands/sub-brands.component.css
// module chunks = main